import React, { useState,useEffect } from 'react'
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import DataTable from 'react-data-table-component';


const AstrologerSummery = () => {
const[summerydata,setSummeryData]=useState([])
 const [startTime, setStartTime] = useState(new Date().toISOString().split("T")[0]);
  const [endTime, setEndTime] = useState(new Date().toISOString().split("T")[0]);
    const [astroName, setAstroName] = useState("");
       const [timeoutId, setTimeoutId] = useState(null);

const fetchSummeryData=async()=>{
  const post={AstroName:astroName,FromDate:startTime,ToDate:endTime}
  try {
     const res=await AddUpdate ("PaymentHistory/GetAstroHistory",post)
    
   
      const data=JSON.parse(res?.data?.data)
      const finaldata=data?.Table
   
      setSummeryData(finaldata)
     

  } catch (error) {
     console.log("error",error)
  }
}

  const columns = [
    {
      name: "Astrologer Name",
      selector: (row) => row.DisplayName,
      sortable: true,
       
    },
    
    {
      name: "Total Calls",
      selector: (row) => row.TotalCalls,
      sortable: true,
      
    },
   
    {
      name: "Repeat Calls",
      selector: (row) => row.RepeatedCalls,
      sortable: true,
    },
   {
      name: "Total Chats",
      selector: (row) => row.TotalChats,
      sortable: true,
      
    },
   
    {
      name: "Repeat Chats",
      selector: (row) => row.RepeatedChats,
      sortable: true,
    },

     {
      name: "Suggested Gemstones",
      selector: (row) => row.TotalGemStone,
      sortable: true,
       
    },
    
    {
      name: "BuyGemStone",
      selector: (row) => row.BuyGemStone,
      sortable: true,
      
    },
   
    {
      name: "Suggested Puja",
      selector: (row) => row.TotalPuja,
      sortable: true,
    },
   {
      name: "BuyPuja",
      selector: (row) => row.BuyPuja,
      sortable: true,
      
    },
   
    {
      name: "Total Amount",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
   
   
    

  
  ];

 useEffect(()=>{
    fetchSummeryData()
  },[])


useEffect(() => {
    if (
      astroName.length < 3 
    
    )
      return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
     
      fetchSummeryData()
  
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName]);




const handleSearch = () => {
    if (startTime ) {
      const formatDate = (dateTime) => {
        if (!dateTime) return null;
        const date = new Date(dateTime);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };

      const formattedStartDate = formatDate(startTime);
      const formattedEndDate = formatDate(endTime);

      const data = {
        FromDate: formattedStartDate,
        Todate: formattedEndDate,
      };

       
        fetchSummeryData()
    }
  };
  return (
   <>

  <div className="form-group  main_card">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Astorolger Summary</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
           
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
       
        <div className="row mt-3 ">
          
           <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
            
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

       

          <div className="col-auto">
            <button className="btn btn-primary ms-2 mt-3" onClick={handleSearch}>
              Search
            </button>
          
          </div>
        </div>
      </div>

 <div className="col-12 mt-2  main_card">
        
          <DataTable
            dense
            data={summerydata || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            customStyles={customStyles}
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
          />
       
      </div>

   </>
  )
}

export default AstrologerSummery;